/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


/**
 * POST /api/v1/support/requests/ — in-app "Request Support" relay.
 *
 * Stateless pass-through to Linear: the issue (plus attached Customer
 * Request) is the only record. If Linear is unreachable the user gets a
 * 502 and retries — nothing is stored locally, so nothing can be silently
 * lost. The ack email's reply-to is support@, so follow-ups land in
 * Linear's Asks intake.
 */

export const supportRequestsCreateBodyPageUrlDefault = ``;

export const SupportRequestsCreateBody = zod.object({
  "category": zod.enum(['question', 'problem', 'feature_request', 'billing']).describe('\* `question` - Question\n\* `problem` - Problem\n\* `feature_request` - Feature request\n\* `billing` - Billing'),
  "message": zod.string().min(1),
  "pageUrl": zod.string().url().default(supportRequestsCreateBodyPageUrlDefault)
})

export const SupportRequestsCreateResponse = zod.object({
  "issueIdentifier": zod.string().describe('Human-readable Linear issue identifier, e.g. \'ASK-123\'.')
}).strict()

